import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { BaseRoute } from 'Components'

generalRouter = (routes, Switcher = Switch, CustomRoute = BaseRoute) ->

  defRoute = routes.find(({ isDefault }) -> isDefault? ) or routes[0]
  defRouteProps = { key: 'default', _.omit(defRoute, 'path')... } # default to match all paths

  (props) ->
    <Switcher>
      {routes
        .map((route) -> { key: route.path, route... })
        .map((route) -> <CustomRoute {...route} />)
        .concat(<CustomRoute {...defRouteProps} />)
      }
    </Switcher>

export default generalRouter
